const policyCancellationType = {
    PRORATA_CANCELLATION : 'Pro Rata',

    FLAT_CANCELLATION : 'Flat - at inception',

    SHORT_RATE_CANCELLATION : 'Short Rate',

    EARNED_IN_FULL : 'Earned in Full',

    OTHER_CANCELLATION : 'Other'

};

angular.module('gw-um-j2js')
    .constant('policyCancellationType', policyCancellationType);